import React from "react";
import styles from "./Settings.module.css"; // we'll use CSS instead of inline RN style
import { ReactComponent as InfoIcon } from "../../../assets/icons/svg/information.svg";
import { ReactComponent as FaceAgent } from "../../../assets/icons/svg/face-agent.svg";
import { ReactComponent as AppBrackets } from "../../../assets/icons/svg/application-brackets.svg";
import { ReactComponent as ScaleBalance } from "../../../assets/icons/svg/scale-balance.svg";
import { ReactComponent as LockOutline } from "../../../assets/icons/svg/lock-outline.svg";
import { ReactComponent as ChevronRight } from "../../../assets/icons/svg/chevron-right.svg";

export default function Settings() {
  const openLink = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const renderSettingsRow = (Icon, text, onClick) => (
    <div className={styles.rowContainer} onClick={onClick}>
      <Icon className={styles.rowIcon} />
      <div className={styles.rowContent}>
        <p>{text}</p>
      </div>
      <ChevronRight className={styles.rowIcon} />
    </div>
  );

  return (
    <div className={styles.container}>
      <h1 className={styles.headerText}>Settings</h1>

      <section>
        <h2 className={styles.subtitle}>Support</h2>
        {renderSettingsRow(FaceAgent, "Feedback / Support", () =>
          openLink("mailto:support@loggable.net")
        )}
      </section>

      <section>
        <h2 className={styles.subtitle}>About</h2>
        {renderSettingsRow(AppBrackets, "About Loggable", () =>
          openLink("https://loggable.net")
        )}
        {renderSettingsRow(LockOutline, "Privacy Policy", () =>
          openLink("https://loggable.net/privacy")
        )}
        {renderSettingsRow(ScaleBalance, "Terms of Service", () =>
          openLink("https://loggable.net/terms")
        )}
      </section>
    </div>
  );
}
